import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { EntityHolisticlock } from "../../entity/EntityHolisticlock";

export class DtoHolisticlocksGetReq extends EntityHolisticlock {
  public IsValid(): string[] {
    let res: string[] = new Array();
    //単項目チェック
    //--------------
    if (!commonRegx.isMatch(this.c_holisticlock_id!.toString(), "^\\d+$", commonRegx._stdOption)) {
      res.push("type error");
    }

    return res;
  }
}
